export const GET_PLAYERS_NOTE_TYPE = 'GET_PLAYERS_NOTE_TYPE';
export const GET_PLAYER_NOTE = 'GET_PLAYER_NOTE';
export const SET_PLAYER_NOTE = 'SET_PLAYER_NOTE';
